/**
 * TS wrapper for getting error message
 */
export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

/**
 * Convenience function for logging caught error to the console
 */
export function reportErrorToConsole(error: unknown) {
  console.error(getErrorMessage(error));
}
